import {Injectable} from '@angular/core';
import {EchUtils} from './ech-utils/ech-utils';
import {Observable, shareReplay} from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private permissionObservableMap=new Map<string,  Observable<Object>>;

  constructor(private echUtils:EchUtils) {

  }


  getPermissionList(serviceName:string,state: number):Observable<any> {
    let uri = ["/api/permission/getPermissionList",serviceName,state].join("/");
    let permissionObservable = this.permissionObservableMap.get(uri);
    if(!permissionObservable){
      permissionObservable = this.echUtils.postObservable(uri).pipe(shareReplay(1));
      this.permissionObservableMap.set(uri,permissionObservable);
    }
    return permissionObservable;
  }
}
